import React, { useState } from "react";
import { createBussinesApi } from "../helpers/getStarted/createBussinesApi";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import SwalAlertComp from "./SwalAlert";

const BussinesModal = (props) => {
  const [form, setForm] = useState({});
  const [createErrors, setCreateErrors] = useState({});
  const language = useSelector((state) => state.languagesState.languages);

  const findFormErrors = () => {
    const {
      contact_email,
      contact_name,
      bussines_name,
      country,
      contact_phone,
      currency,
      bussines_vertical,
    } = form;
    const newErrors = {};
    if (!contact_email || contact_email === "") newErrors.contact_email = "Cannot be blank!";
    if (!contact_name || contact_name === "") newErrors.contact_name = "Cannot be blank!";
    if (!bussines_name || bussines_name === "") newErrors.bussines_name = "Cannot be blank!";
    if (!country || country === "") newErrors.country = "Cannot be blank!";
    if (!contact_phone || contact_phone === "") newErrors.contact_phone = "Cannot be blank!";
    if (!currency || currency === "") newErrors.currency = "Cannot be blank!";
    if (!bussines_vertical || bussines_vertical === "") newErrors.bussines_vertical = "Cannot be blank!";

    return newErrors;
  };
  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
    if (!!createErrors[field])
      setCreateErrors({
        ...createErrors,
        [field]: null,
      });
  };
  const createBussiness = async () => {
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      setCreateErrors(newErrors);
    } else {
      let sendForm = {
        access_token:
          props.data &&
          props.data.tokenDetail &&
          props.data.tokenDetail.accessToken &&
          props.data.tokenDetail.accessToken,
        email: form.contact_email && form.contact_email,
        name: form.contact_name && form.contact_name,
        business_name: form.bussines_name && form.bussines_name,
        country: form.country && form.country,
        phone: form.contact_phone && form.contact_phone,
        currency: form.currency && form.currency,
        business_vertical: form.bussines_vertical && form.bussines_vertical,
      };
      let result = await createBussinesApi(sendForm);
      if (result.status) {
        if (result.data) {
          props.updatedDataBussines(result.data && result.data);
        }
      } else {
        SwalAlertComp({
          title: language?.delete_swal_modal?.failed ?? "Failed",
          message: result.message && result.message,
          icon: "error",
        });
      }
    }
  };

  return (
    <div>
      <div className="panel-body row">
        <form role="form" className="col-12" name="business_form" id="business_form">
          <div className="row  mb-2">
            <div className="col">
              <div className="form-group">
                <Form.Control
                  as="select"
                  className="form-control"
                  name="country"
                  placeholder={language?.bussines_modal?.country ?? "Country"}
                  id="country"
                  value={form.country && form.country}
                  isInvalid={!!createErrors.country}
                  onChange={(e) => setField("country", e.target.value)}
                >
                  <option value="">{language?.bussines_modal?.select_country ?? "Select Country"}</option>
                  <option value="AF">Afghanistan</option>
                  <option value="AL">Albania</option>
                  <option value="DZ">Algeria</option>
                  <option value="AS">American Samoa</option>
                  <option value="AD">Andorra</option>
                  <option value="AO">Angola</option>
                  <option value="AI">Anguilla</option>
                  <option value="AQ">Antarctica</option>
                  <option value="AG">Antigua and Barbuda</option>
                  <option value="AR">Argentina</option>
                  <option value="AM">Armenia</option>
                  <option value="AW">Aruba</option>
                  <option value="AU">Australia</option>
                  <option value="AT">Austria</option>
                  <option value="AZ">Azerbaijan</option>
                  <option value="BS">Bahamas</option>
                  <option value="BH">Bahrain</option>
                  <option value="BD">Bangladesh</option>
                  <option value="BB">Barbados</option>
                  <option value="BY">Belarus</option>
                  <option value="BE">Belgium</option>
                  <option value="BZ">Belize</option>
                  <option value="BJ">Benin</option>
                  <option value="BM">Bermuda</option>
                  <option value="BT">Bhutan</option>
                  <option value="BO">Bolivia</option>
                  <option value="BA">Bosnia and Herzegowina</option>
                  <option value="BW">Botswana</option>
                  <option value="BV">Bouvet Island</option>
                  <option value="BR">Brazil</option>
                  <option value="IO">British Indian Ocean Territory</option>
                  <option value="BN">Brunei Darussalam</option>
                  <option value="BG">Bulgaria</option>
                  <option value="BF">Burkina Faso</option>
                  <option value="BI">Burundi</option>
                  <option value="KH">Cambodia</option>
                  <option value="CM">Cameroon</option>
                  <option value="CA">Canada</option>
                  <option value="CV">Cape Verde</option>
                  <option value="KY">Cayman Islands</option>
                  <option value="CF">Central African Republic</option>
                  <option value="TD">Chad</option>
                  <option value="CL">Chile</option>
                  <option value="CN">China</option>
                  <option value="CX">Christmas Island</option>
                  <option value="CC">Cocos (Keeling) Islands</option>
                  <option value="CO">Colombia</option>
                  <option value="KM">Comoros</option>
                  <option value="CG">Congo</option>
                  <option value="CK">Cook Islands</option>
                  <option value="CR">Costa Rica</option>
                  <option value="CI">Cote D'Ivoire</option>
                  <option value="HR">Croatia</option>
                  <option value="CU">Cuba</option>
                  <option value="CY">Kıbrıs</option>
                  <option value="CZ">Czech Republic</option>
                  <option value="DK">Denmark</option>
                  <option value="DJ">Djibouti</option>
                  <option value="DM">Dominica</option>
                  <option value="DO">Dominican Republic</option>
                  <option value="TP">East Timor</option>
                  <option value="EC">Ecuador</option>
                  <option value="EG">Egypt</option>
                  <option value="SV">El Salvador</option>
                  <option value="GQ">Equatorial Guinea</option>
                  <option value="ER">Eritrea</option>
                  <option value="EE">Estonia</option>
                  <option value="ET">Ethiopia</option>
                  <option value="FK">Falkland Islands (Malvinas)</option>
                  <option value="FO">Faroe Islands</option>
                  <option value="FJ">Fiji</option>
                  <option value="FI">Finland</option>
                  <option value="FR">France</option>
                  <option value="FX">France, Metropolitan</option>
                  <option value="GF">French Guiana</option>
                  <option value="PF">French Polynesia</option>
                  <option value="TF">French Southern Territories</option>
                  <option value="GA">Gabon</option>
                  <option value="GM">Gambia</option>
                  <option value="GE">Georgia</option>
                  <option value="DE">Germany</option>
                  <option value="GH">Ghana</option>
                  <option value="GI">Gibraltar</option>
                  <option value="GR">Greece</option>
                  <option value="GL">Greenland</option>
                  <option value="GD">Grenada</option>
                  <option value="GP">Guadeloupe</option>
                  <option value="GU">Guam</option>
                  <option value="GT">Guatemala</option>
                  <option value="GN">Guinea</option>
                  <option value="GW">Guinea-bissau</option>
                  <option value="GY">Guyana</option>
                  <option value="HT">Haiti</option>
                  <option value="HM">Heard and Mc Donald Islands</option>
                  <option value="HN">Honduras</option>
                  <option value="HK">Hong Kong</option>
                  <option value="HU">Hungary</option>
                  <option value="IS">Iceland</option>
                  <option value="IN">India</option>
                  <option value="ID">Indonesia</option>
                  <option value="IR">Iran</option>
                  <option value="IQ">Iraq</option>
                  <option value="IE">Ireland</option>
                  <option value="IL">Israel</option>
                  <option value="IT">Italy</option>
                  <option value="JM">Jamaica</option>
                  <option value="JP">Japan</option>
                  <option value="JO">Jordan</option>
                  <option value="KZ">Kazakhstan</option>
                  <option value="KE">Kenya</option>
                  <option value="KI">Kiribati</option>
                  <option value="KP">North Korea</option>
                  <option value="KR">Korea, Republic of</option>
                  <option value="KW">Kuwait</option>
                  <option value="KG">Kyrgyzstan</option>
                  <option value="LA">Lao People's Democratic Republic</option>
                  <option value="LV">Latvia</option>
                  <option value="LB">Lebanon</option>
                  <option value="LS">Lesotho</option>
                  <option value="LR">Liberia</option>
                  <option value="LY">Libyan</option>
                  <option value="LI">Liechtenstein</option>
                  <option value="LT">Lithuania</option>
                  <option value="LU">Luxembourg</option>
                  <option value="MO">Macau</option>
                  <option value="MK">Macedonia</option>
                  <option value="MG">Madagascar</option>
                  <option value="MW">Malawi</option>
                  <option value="MY">Malaysia</option>
                  <option value="MV">Maldives</option>
                  <option value="ML">Mali</option>
                  <option value="MT">Malta</option>
                  <option value="MH">Marshall Islands</option>
                  <option value="MQ">Martinique</option>
                  <option value="MR">Mauritania</option>
                  <option value="MU">Mauritius</option>
                  <option value="YT">Mayotte</option>
                  <option value="MX">Mexico</option>
                  <option value="FM">Micronesia, Federated States of</option>
                  <option value="MD">Moldova, Republic of</option>
                  <option value="MC">Monaco</option>
                  <option value="MN">Mongolia</option>
                  <option value="MS">Montserrat</option>
                  <option value="MA">Morocco</option>
                  <option value="MZ">Mozambique</option>
                  <option value="MM">Myanmar</option>
                  <option value="NA">Namibia</option>
                  <option value="NR">Nauru</option>
                  <option value="NP">Nepal</option>
                  <option value="NL">Netherlands</option>
                  <option value="AN">Netherlands Antilles</option>
                  <option value="NC">New Caledonia</option>
                  <option value="NZ">New Zealand</option>
                  <option value="NI">Nicaragua</option>
                  <option value="NE">Niger</option>
                  <option value="NG">Nigeria</option>
                  <option value="NU">Niue</option>
                  <option value="NF">Norfolk Island</option>
                  <option value="MP">Northern Mariana Islands</option>
                  <option value="NO">Norway</option>
                  <option value="OM">Oman</option>
                  <option value="PK">Pakistan</option>
                  <option value="PW">Palau</option>
                  <option value="PA">Panama</option>
                  <option value="PG">Papua New Guinea</option>
                  <option value="PY">Paraguay</option>
                  <option value="PE">Peru</option>
                  <option value="PH">Philippines</option>
                  <option value="PN">Pitcairn</option>
                  <option value="PL">Poland</option>
                  <option value="PT">Portugal</option>
                  <option value="PR">Puerto Rico</option>
                  <option value="QA">Qatar</option>
                  <option value="RE">Reunion</option>
                  <option value="RO">Romania</option>
                  <option value="RU">Russian Federation</option>
                  <option value="RW">Rwanda</option>
                  <option value="KN">Saint Kitts and Nevis</option>
                  <option value="LC">Saint Lucia</option>
                  <option value="VC">Saint Vincent and the Grenadines</option>
                  <option value="WS">Samoa</option>
                  <option value="SM">San Marino</option>
                  <option value="ST">Sao Tome and Principe</option>
                  <option value="SA">Saudi Arabia</option>
                  <option value="SN">Senegal</option>
                  <option value="SC">Seychelles</option>
                  <option value="SL">Sierra Leone</option>
                  <option value="SG">Singapore</option>
                  <option value="SK">Slovakia</option>
                  <option value="SI">Slovenia</option>
                  <option value="SB">Solomon Islands</option>
                  <option value="SO">Somalia</option>
                  <option value="ZA">South Africa</option>
                  <option value="GS">South Georgia &amp; South Sandwich Islands</option>
                  <option value="ES">Spain</option>
                  <option value="LK">Sri Lanka</option>
                  <option value="SH">St. Helena</option>
                  <option value="PM">St. Pierre and Miquelon</option>
                  <option value="SD">Sudan</option>
                  <option value="SR">Suriname</option>
                  <option value="SJ">Svalbard and Jan Mayen Islands</option>
                  <option value="SZ">Swaziland</option>
                  <option value="SE">Sweden</option>
                  <option value="CH">Switzerland</option>
                  <option value="SY">Syria</option>
                  <option value="TW">Taiwan</option>
                  <option value="TJ">Tajikistan</option>
                  <option value="TZ">Tanzania, United Republic of</option>
                  <option value="TH">Thailand</option>
                  <option value="TG">Togo</option>
                  <option value="TK">Tokelau</option>
                  <option value="TO">Tonga</option>
                  <option value="TT">Trinidad and Tobago</option>
                  <option value="TN">Tunisia</option>
                  <option value="TR">Türkiye</option>
                  <option value="TM">Turkmenistan</option>
                  <option value="TC">Turks and Caicos Islands</option>
                  <option value="TV">Tuvalu</option>
                  <option value="UG">Uganda</option>
                  <option value="UA">Ukraine</option>
                  <option value="AE">United Arab Emirates</option>
                  <option value="GB">United Kingdom</option>
                  <option value="US">United States</option>
                  <option value="UM">United States Minor Outlying Islands</option>
                  <option value="UY">Uruguay</option>
                  <option value="UZ">Uzbekistan</option>
                  <option value="VU">Vanuatu</option>
                  <option value="VA">Vatican City State (Holy See)</option>
                  <option value="VE">Venezuela</option>
                  <option value="VN">Viet Nam</option>
                  <option value="VG">Virgin Islands (British)</option>
                  <option value="VI">Virgin Islands (U.S.)</option>
                  <option value="WF">Wallis and Futuna Islands</option>
                  <option value="EH">Western Sahara</option>
                  <option value="YE">Yemen</option>
                  <option value="XK">Kosovo</option>
                  <option value="CD">Democratic Republic of Congo</option>
                  <option value="ZM">Zambia</option>
                  <option value="ZW">Zimbabwe</option>
                  <option value="GG">Guernsey</option>
                  <option value="PS">Palestine</option>
                  <option value="RS">Serbia</option>
                  <option value="ME">Montenegro</option>
                  <option value="OT">Other</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">{!!createErrors.country}</Form.Control.Feedback>
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col">
              <div className="col-xs-12">
                <div className="form-group">
                  <Form.Control
                    placeholder={language?.bussines_modal?.business_name ?? "Business Name"}
                    type="text"
                    className="form-control"
                    name="business_name"
                    id="business_name"
                    value={form.bussines_name && form.bussines_name}
                    required
                    isInvalid={!!createErrors.bussines_name}
                    onChange={(e) => setField("bussines_name", e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="col-xs-12">
                <div className="form-group">
                  <Form.Control
                    placeholder={language?.bussines_modal?.contact_name ?? "Contact Name"}
                    type="text"
                    className="form-control"
                    isInvalid={!!createErrors.contact_name}
                    value={form.contact_name && form.contact_name}
                    onChange={(e) => setField("contact_name", e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col">
              <div className="col-xs-12">
                <div className="form-group">
                  <Form.Control
                    placeholder={language?.bussines_modal?.contact_email ?? "Contact Email"}
                    type="text"
                    className="form-control"
                    value={form.contact_email && form.contact_email}
                    isInvalid={!!createErrors.contact_email}
                    onChange={(e) => setField("contact_email", e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="col-xs-12">
                <div className="form-group">
                  <Form.Control
                    placeholder={language?.bussines_modal?.contact_phone ?? "Contact Phone"}
                    type="text"
                    className="form-control"
                    value={form.contact_phone && form.contact_phone}
                    isInvalid={!!createErrors.contact_phone}
                    onChange={(e) => setField("contact_phone", e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col">
              <div className="col-xs-12">
                <div className="form-group">
                  <Form.Control
                    as="select"
                    className="form-control"
                    isInvalid={!!createErrors.bussines_vertical}
                    value={form.bussines_vertical && form.bussines_vertical}
                    onChange={(e) => setField("bussines_vertical", e.target.value)}
                  >
                    <option value="">{language?.bussines_modal?.select_business_sector ?? "Select Business Sector"}</option>
                    <option value="ECOMMERCE">{language?.bussines_modal?.e_commerce ?? "E-commerce"}</option>
                    <option value="SERVICES">{language?.bussines_modal?.services ?? "Services"}</option>
                    <option value="FOOD_AND_DRINK">{language?.bussines_modal?.food_and_drink ?? "Food And Drink"}</option>
                    <option value="CREATIVE">{language?.bussines_modal?.creative ?? "Creative"}</option>
                    <option value="ADS_TARGETING">{language?.bussines_modal?.ads_targeting ?? "Ads Targeting"}</option>
                    <option value="LEAD_ADS">{language?.bussines_modal?.lead_ads ?? "Lead Ads"}</option>
                    <option value="MEASUREMENT_AND_OPTIMIZATION">{language?.bussines_modal?.measurement_and_optimization ?? "Measurement And Optimization"}</option>
                  </Form.Control>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="col-xs-12">
                <div className="form-group">
                  <Form.Control
                    as="select"
                    isInvalid={!!createErrors.currency}
                    className="form-control"
                    value={form.currency && form.currency}
                    onChange={(e) => setField("currency", e.target.value)}
                  >
                    <option value="">{language?.bussines_modal?.select_currency ?? "Select Currency"}</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="GBP">GBP</option>
                    <option value="TRY">TRY</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="SAR">SAR</option>
                    <option value="EGP">EGP</option>
                    <option value="AED">AED</option>
                    <option value="QAR">QAR</option>
                    <option value="ZAR">ZAR</option>
                    <option value="MYR">MYR</option>
                    <option value="SEK">SEK</option>
                    <option value="NZD">NZD</option>
                    <option value="PHP">PHP</option>
                  </Form.Control>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="panel-footer row">
        <div className="col-12">
          <div>
            <button className="btn btn-info btn-lg btn-block mt-2" onClick={createBussiness}>
            {language?.bussines_modal?.create_business ?? "Create business"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BussinesModal;
